import { render, staticRenderFns } from "./LinkModalCustomerSignUp.vue?vue&type=template&id=3636108a&scoped=true"
import script from "./LinkModalCustomerSignUp.vue?vue&type=script&lang=js"
export * from "./LinkModalCustomerSignUp.vue?vue&type=script&lang=js"
import style0 from "./LinkModalCustomerSignUp.vue?vue&type=style&index=0&id=3636108a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3636108a",
  null
  
)

export default component.exports